<template>
  <div v-show="imageURL" class="flex flex-row" @click="showContextMenu = false">
    <!-- Display feilds details -->

    <div @click="displayLeft = !displayLeft" style="height: 24px">
      <MenuAlt2Icon v-if="!displayLeft" class="w-12 h-12 cursor-pointer" />
      <XIcon v-if="displayLeft" class="w-12 h-12 cursor-pointer" />
    </div>
    <div
      v-if="displayLeft"
      class="w-1/6 mb-16 md:flex md:flex-wrap flex flex-col mx-auto"
      style="transition: 0.5s;"
      
    >
    <div class="overflow">
      <div
        v-for="requiredField in requiredFields"
        :key="requiredField.id"
        class="p-4"
      >
        <RequiredFieldsDetails
          :requiredField="requiredField"
          :selectedFieldName="selectedFieldName"
          :addNew="addNew"
          @toggleFieldPolygons="toggleFieldPolygons"
        />
      </div>
    </div>
      
    </div>

    <!-- END END END  -->
    <div class="w-full mx-8 transition: 250px 0.5s" style="height: 70vh">
      <div id="contextMenu" v-show="showContextMenu">
        <ul style="position: relative">
          <!-- <li @click="removePolygon(selectedPolygon)">
          Remove Polygon
        </li> -->
          <!-- <li>Move</li> -->
          <li
            @click="resetPolygonToOriginal(selectedPolygon)"
            class="border-b border-solid border-black"
          >
            Remove Polygon
          </li>
          <li
            @click="toggle(selectedPolygon)"
            class="border-b border-solid border-black"
          >
            Toggle
          </li>
          <li
            @click="dragSingle(selectedPolygon)"
            class="border-b border-solid border-black"
          >
            Drag Single Point
          </li>
          <li
            @click="resize(selectedPolygon)"
            class="border-b border-solid border-black"
          >
            Resize Polygon
          </li>
          <!-- <li
            @click="dragSingle(selectedPolygon)"
            v-if="
              selectedPolygon &&
              polygons[parseInt(selectedPolygon.split('-')[1])].moveAdjacent
            "
            class="border-b border-solid border-black"
          >
            Drag Single Point
          </li>
          <li
            @click="resize(selectedPolygon)"
            v-if="
              selectedPolygon &&
              !polygons[parseInt(selectedPolygon.split('-')[1])].moveAdjacent
            "
            class="border-b border-solid border-black"
          >
            Resize Polygon
          </li> -->
        </ul>
      </div>
      <PinchScrollZoom
        :within="false"
        minScale="0.1"
        maxScale="5"
        ref="zoomer"
        :width="1"
        :height="1"
        style="
          border: 1px solid black;
          height: 100%;
          width: 100%;
          position: relative !important;
        "
        :draggable="isDraggable"
        @scaling="scalingHandler"
      >
        <div
          id="OCRIMAGE"
          class="mx-auto mt-4"
          :style="
            'position:relative;width:' +
            imageWidth +
            'px;height:' +
            imageHeight +
            'px'
          "
          @click="addPoint($event)"
          @dbclick="savePoints($event)"
          :key="refreshKey"
        >
          <ImageComponent
            v-if="imageURL"
            @resetZoom="resetZoom"
            id="picture"
            :url="imageURL + '?session=' + session"
            name="OCR"
            style="z-index: 2 !important"
            @loaded="setDimensions()"
          />
          <svg
            @mouseover="mouseover($event)"
            @mousemove="imagehover($event)"
            @mouseleave="mouseleave($event)"
            id="canvas"
            class="w-full h-full"
            style="position: absolute; z-index: 3 !important; top: 0"
            v-show="imageHeight"
          >
            <defs>
              <pattern
                id="smallGrid"
                width="10"
                height="10"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 10 0 L 0 0 0 10"
                  fill="none"
                  stroke="gray"
                  stroke-width="0.5"
                />
              </pattern>
              <pattern
                id="grid"
                width="100"
                height="100"
                patternUnits="userSpaceOnUse"
              >
                <rect width="100" height="100" fill="url(#smallGrid)" />
                <path
                  d="M 100 0 L 0 0 0 100"
                  fill="none"
                  stroke="gray"
                  stroke-width="1"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
            <polygon
              @contextmenu.prevent="openContextMenu($event, polygon.id)"
              v-for="polygon in polygons"
              :key="polygon.id"
              :id="polygon.id"
              @click="selected(polygon.id)"
              @mouseenter="
                addPolygonLines(polygon.id);
                displayLabel(polygon.id, true);
                isDraggable = false;
              "
              @mousemove="move($event, polygon.id)"
              @mousedown="
                selected(polygon.id);
                saveOriginPoint($event);
              "
              @mouseup="deleteOriginPoint(polygon.id)"
              @mouseleave="
                deleteOriginPoint(polygon.id);
                displayLabel(polygon.id, false);
                isDraggable = true;
              "
              :points="polygon.polygonCoordinates"
              style="stroke-width: 2; opacity: 0.4"
              :style="
                'fill:' +
                polygon.color +
                ';stroke:' +
                polygon.color +
                ';display:' +
                (polygon.display ? 'inline;' : 'none;')
              "
            />
          </svg>
          <span v-for="polygon in polygons" :key="polygon.id">
            <span
              :id="coordinate.id"
              class="dot absolute"
              style="z-index: 7 !important"
              :style="
                'top:' +
                coordinate.y +
                'px;left:' +
                coordinate.x +
                'px;background:' +
                polygon.color +
                ';display:' +
                (polygon.display ? 'inline;' : 'none;')
              "
              v-for="coordinate in polygon.coordinates"
              :key="coordinate.id"
              @mouseenter="
                isDraggable = false;
                drag($event, coordinate.id);
                addPolygonLines(polygon.id);
                displayLineX(coordinate.id, true);
                displayLineY(coordinate.id, true);
              "
              @mouseleave="
                isDraggable = true;
                displayLineX(coordinate.id, false);
                displayLineY(coordinate.id, false);
              "
            ></span>
          </span>
          <span
            v-for="polygon in polygons"
            :key="polygon.id + '-label'"
            :id="polygon.id + '-label'"
            class="absolute"
            :style="
              'top:' +
              polygon.labelCoordinates.y +
              'px;left:' +
              polygon.labelCoordinates.x +
              'px;font-size:12px;background-color:white;border-radius:2px;display:none;' +
              'transform: translate(-50%,-50%);'
            "
          >
            {{ polygon.title }}</span
          >
        </div>
      </PinchScrollZoom>
      <div class="flex flex-row justify-center gap-1 w-full">
        <div class="h-full my-auto">
          <button
            @click="submitImage()"
            class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
          >
            Submit Image
          </button>
        </div>
        <div class="h-full my-auto">
          <button
            @click="resetZoom()"
            class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
          >
            Reset
          </button>
        </div>

        <div class="h-full my-auto">
          <button
            @click="toggleAll()"
            class="bg-woo hover:bg-hoverwoo text-whiteText label p-2"
          >
            Toggle All
          </button>
        </div>

        <div class="relative text-xs">
          <button
            id="options"
            style=""
            class="flex content-between label px-3 py-2 bg-woo hover:bg-woo text-white border border-gray-500"
            @click="isOptionsExpanded = !isOptionsExpanded"
            @blur="isOptionsExpanded = false"
          >
            <span>{{ imageStatus }}</span>
            <svg
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="h-4 w-4 transform transition-transform duration-200 ease-in-out"
              :class="isOptionsExpanded ? 'rotate-180' : 'rotate-0'"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          <transition
            enter-active-class="transform transition duration-500 ease-custom"
            enter-class="-translate-y-1/2 scale-y-0 opacity-0"
            enter-to-class="translate-y-0 scale-y-100 opacity-100"
            leave-active-class="transform transition duration-300 ease-custom"
            leave-class="translate-y-0 scale-y-100 opacity-100"
            leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
          >
            <ul
              v-show="isOptionsExpanded"
              class="absolute left-0 right-0 mb-4 bg-white divide-y rounded-lg shadow-lg overflow-hidden"
            >
              <li
                v-for="(option, index) in options"
                :key="index"
                class="px-3 py-2 transition-colors duration-300 hover:bg-gray-200 cursor-pointer font-extrabold"
                @mousedown.prevent="setOption(option)"
              >
                {{ option }}
              </li>
            </ul>
          </transition>
        </div>
        <!-- *********************** -->
      </div>
    </div>

    <!-- Display polygon details -->

    <div
      v-if="displayRight && polygons"
      class="w-1/4 md:flex md:flex-wrap flex flex-col mx-auto"
    >
      <div v-if="polygons.length" class="overflow">
        <div
          v-for="polygon in polygons"
          :key="polygon.id"
          :id="polygon.id + '-div'"
          class=""
          :style="'border-color:#' + polygon.color"
          @mouseenter="displayLabel(polygon.id, true)"
          @mouseleave="displayLabel(polygon.id, false)"
        >
          <!-- show polygon -->
          <PolygonDetails
            v-if="polygon.displayInfo"
            :polygon="polygon"
            :requiredFields="requiredFields"
            @deletePolygon="deletePolygon"
            @toggle="toggle"
            @changeClass="changeClass"
          />
        </div>
      </div>
      <div v-else class="italic">No annotations available</div>
    </div>

    <span v-if="selectedFieldName && drawPolygon" id="tooltip-span">{{
      selectedFieldName
    }}</span>

    <div
      v-if="polygons"
      @click="displayRight = !displayRight"
      style="height: 24px"
    >
      <MenuAlt3Icon v-if="!displayRight" class="w-12 h-12 cursor-pointer" />
      <XIcon v-if="displayRight" class="w-12 h-12 cursor-pointer" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Http, { OCR_ENDPOINTS } from "../request";
import ImageComponent from "../components/ImageComponent.vue";
import PolygonDetails from "../components/PolygonDetails.vue";
import { Modal } from "../helpers/Modal";
import { MenuAlt2Icon, MenuAlt3Icon } from "@vue-hero-icons/solid";
import { XIcon } from "@vue-hero-icons/solid";
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
import RequiredFieldsDetails from "../components/requiredFieldsDetails.vue";
export default {
  name: "",
  data() {
    return {
      first: true,
      isOptionsExpanded: false,
      imageStatus: null,
      options: ["DONE", "IN PROGRESS", "IRRELEVANT"],
      modifyPolygon: false,
      selectedFieldName: null,
      displayRight: false,
      displayLeft: false,
      session: this.$store.state.id,
      isDraggable: true,
      drawPolygon: false,
      requiredFields: [],
      loading: false,
      polygons: [],
      initialAnnotations: [],
      imageWidth: 0,
      imageHeight: 0,
      selectedPolygon: null,
      selectedPolygonColor: null,
      showColorMenu: false,
      showContextMenu: false,
      originalPolygons: [],
      index: 0,
      refreshKey: 0,
      imageURL: null,
      arrayBuffer: null,
      colorDialogTop: null,
      moveStartX: null,
      moveStartY: null,
      result: [],
      delay: 200,
      clicks: 0,
      timer: null,
      scale: null,
      toggleFields: false,
    };
  },
  components: {
    PinchScrollZoom,
    ImageComponent,
    PolygonDetails,
    XIcon,
    MenuAlt2Icon,
    MenuAlt3Icon,
    RequiredFieldsDetails,
  },
  updated() {},
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Enter") {
        this.savePoints();
      }
    });

    this.setOCRData();
  },
  mounted() {},
  props: { selectedImageID: String },
  watch: {
    selectedImageID(val, oldVal) {
      this.polygons = [];
      this.originalPolygons = [];
      this.setOCRData();
    },
  },
  methods: {
    changeClass(polygonId, polygonName, fieldName) {
      const found = this.polygons.find((element) => element.id == polygonId);
      found.title = polygonName;
      found.fieldId = fieldName;
    },

    setOption(option) {
      this.imageStatus = option;
      this.imageStatus = this.imageStatus.split(" ").join("_").toUpperCase();
      this.isOptionsExpanded = false;

      Http()
        .patch(
          OCR_ENDPOINTS.imagesAnnotation + this.selectedImageID + "/status",
          {
            status: this.imageStatus,
          }
        )
        .then((response) => {
          this.imageStatus = response.data.status.name.split("_").join(" ");
          this.$toast.success("Status: " + this.imageStatus);
        })
        .catch((error) => {
          this.$toast.error("Error Occured");
          console.error(error);
        });

      this.imageStatus = this.imageStatus.split("_").join(" ");
    },

    imagehover(e) {
      if (this.selectedFieldName) {
        var toolTip = document.getElementById("tooltip-span");
        if (toolTip) {
          toolTip.style.position = "absolute";
          toolTip.style.left = e.x + "px";
          toolTip.style.top = e.y + 50 + "px";
        }
      }
    },
    mouseover() {
      if (this.selectedFieldName) {
        var toolTip = document.getElementById("tooltip-span");

        if (toolTip && toolTip.style.display != "block") {
          toolTip.style.display = "block";
        }
      }
    },
    mouseleave() {
      if (this.selectedFieldName) {
        var toolTip = document.getElementById("tooltip-span");
        if (toolTip) {
          toolTip.style.display = "none";
        }
      }
    },
    resetZoom() {
      var container = document.getElementsByClassName("pinch-scroll-zoom");
      let widthContainer = container[0].offsetWidth;
      let heightContainer = container[0].offsetHeight;

      const image = document.getElementById("picture");
      let widthImage = image.offsetWidth;
      let heightImage = image.offsetHeight;

      let scale = heightContainer / heightImage;
      this.scale = scale;
      this.$refs.zoomer.setData({
        scale: scale,
        originX: widthContainer / 2,
        originY: 0,
        translateX: 0,
        translateY: 0,
      });
    },
    scalingHandler(e) {
      this.scale = e.scale;
    },
    addNew(id, name) {
      if (this.drawPolygon) {
        if (this.polygons[this.polygons.length - 1].coordinates.length < 3) {
          this.drawPolygon = false;
          this.selectedFieldName = name;
          this.polygons.pop();
          this.addNew(id, name);
        } else {
          Modal.showConfirmationModal({
            message: "Are You Sure You Would Like to start new polygon?",
            title: "Confirm ",
          }).then((confirmed) => {
            if (confirmed) {
              this.drawPolygon = false;
              this.selectedFieldName = name;
              this.polygons.pop();
              this.addNew(id, name);
            }
          });
        }
      } else {
        this.selectedFieldName = name;
        this.polygons.push({
          title: _.startCase(name),
          coordinates: [],
          width: null,
          height: null,
          displayInfo: false,
          labelCoordinates: { x: 0, y: 0 },
          display: false,
          id: "polygon-" + this.index,
          hasValue: name != "image",
          fieldId: id,
          value: null,
          drawPolygonData: {},
        });
        this.drawPolygon = true;
        this.drawPolygonId = "polygon-" + this.index;
        this.index++;
      }
      this.color = this.polygons[this.polygons.length - 1].color;
    },

    async getImage() {
      // this.$emit("loading", true);

      await Http()
        .get(OCR_ENDPOINTS.images + "/" + this.selectedImageID, {})
        .then((response) => {
          response.data.arrayBuffer = this.arrayBuffer;
          this.imageStatus = response.data.status.name.split("_").join(" ");
          this.imageURL = response.data.url;
          this.index = 0;
          this.requiredFields = response.data.type.requiredFields;
          this.requiredFields.sort((a, b) => {
            return a.id - b.id;
          });

          let requiredFieldColors = {};
          let color= '';
          for (var i = 0; i < this.requiredFields.length; i++) {
            if (this.requiredFields[i].color != null && this.requiredFields[i].color!="") {
              color = this.requiredFields[i].color;
            }
            else{
              color = this.getRandomColor(i);
            }
            let name = this.requiredFields[i].name;
            requiredFieldColors[name] = color;
          }
          for (var requiredField of this.requiredFields) {
            requiredField.color = requiredFieldColors[requiredField.name];
          }
          for (var annotation of response.data.imageAnnotations) {
            this.polygonsAnnotations(annotation);
          }
          this.updateAnnotations(response.data.imageAnnotations);
          // this.$store.commit("updateBatchImages", response.data);
          // this.$emit("loading", false);
        });
    },
    polygonsAnnotations(annotation) {
      this.polygons.push({
        title: _.startCase(annotation.field.name),
        coordinates: [],
        width: null,
        height: null,
        displayInfo: true,
        labelCoordinates: { x: 0, y: 0 },
        display: false,
        id: "polygon-" + this.index,
        hasValue: annotation.field.name != "image",
        fieldId: annotation.field.id,
        annotationId: annotation.id,
        value: annotation.field.value,
      });

      this.index++;
    },
    updateAnnotations(annotations) {
      setTimeout(() => this.resetZoom(), 1);

      var update = false;

      if (annotations.length != 0) {
        for (var polygon of this.polygons) {
          var annotationsOfCurrentField = annotations.filter(
            (annotation) => annotation.id == polygon.annotationId
          );

          if (annotationsOfCurrentField.length != 0) {
            update = true;
            var mostRecentDate = Date.parse(
              annotationsOfCurrentField[0].creationDate
            );
            var mostRecentDateIndex = 0;
            var index = 0;
            for (var dateAnnotation of annotationsOfCurrentField) {
              var annotationDate = Date.parse(dateAnnotation.creationDate);
              if (annotationDate > mostRecentDate) {
                mostRecentDate = annotationDate;
                mostRecentDateIndex = index;
              }
              index++;
            }

            var sortedCoordinates = annotationsOfCurrentField[
              mostRecentDateIndex
            ].field.coordinateList.sort(function (a, b) {
              return a.id - b.id;
            });
            polygon.coordinates = _.cloneDeep(sortedCoordinates);
            polygon.value =
              annotationsOfCurrentField[mostRecentDateIndex].field.value;
          }
        }
      }
      if (update) {
        this.setPolygons();
      }
      let annotatedFields = [];
      for (var polygon of this.polygons) {
        var coordinates = [];
        for (var coordinate of polygon.coordinates) {
          coordinates.push({ x: coordinate.x, y: coordinate.y });
        }
        if (coordinates.length != 0) {
          annotatedFields.push({
            imageAnnotationFieldId: polygon.fieldId,
            annotationValue: polygon.value,
            coordinates: coordinates,
          });
        }
      }
      this.initialAnnotations = annotatedFields;
    },
    async setOCRData() {
      this.refreshKey++;
      await this.getImage();
    },
    setPolygons() {
      const idPoly = this.polygons.map((o) => o.annotationId);
      this.polygons = this.polygons.filter(
        ({ id }, index) => !idPoly.includes(id, index + 1)
      );
      for (var i in this.polygons) {
        var polygon = this.polygons[i];
        polygon.width = this.getWidth(polygon.coordinates);
        polygon.height = this.getHeight(polygon.coordinates);
        if (polygon.moveAdjacent == null || polygon.moveAdjacent == undefined) {
          polygon.moveAdjacent = false;
        }
        polygon.display = true;
        // if (!polygon.scale) {
        //   polygon.scale = 100;
        // }
        if (!polygon.id) {
          polygon.id = "polygon-" + this.index;
          this.index++;
        }
        if (!polygon.color) {
          polygon.color = this.getPolygonColor(polygon);
        }
        polygon.polygonCoordinates = "";
        var yCoordinate = [];
        var xCoordinate = [];
        for (var j in polygon.coordinates) {
          var coordinate = polygon.coordinates[j];
          if (!coordinate.scaleX && !coordinate.scaleX) {
            coordinate.scaleX = coordinate.x;
            coordinate.scaleY = coordinate.y;
          }
          yCoordinate.push(coordinate.y);
          xCoordinate.push(coordinate.x);
          coordinate.id = polygon.id + "-dot-" + j;
          coordinate.lineX = {
            x1: coordinate.x,
            x2: coordinate.x,
            y1: 0,
            y2: this.imageHeight,
          };
          coordinate.lineY = {
            x1: 0,
            x2: this.imageWidth,
            y1: coordinate.y,
            y2: coordinate.y,
          };
          this.addCoordinateLines(coordinate.id);
          polygon.polygonCoordinates += coordinate.x + "," + coordinate.y + " ";
        }
        if (polygon.coordinates.length != 0) {
          var center = this.getCenter(polygon.coordinates);
          polygon.labelCoordinates = {
            x: center.x,
            y: center.y,
          };
        }
        polygon.polygonCoordinates = polygon.polygonCoordinates.trim();
      }
    },
    getPolygonColor(polygon) {
      for (var requiredField of this.requiredFields) {
        if (polygon.fieldId == requiredField.id) {
          return requiredField.color;
        }
      }
    },
    addPoint(event) {
      if (this.drawPolygon) {
        this.clicks++;
        if (this.clicks === 1) {
          this.timer = setTimeout(() => {
            this.drawPolygonData = this.polygons.filter(
              (polygon) => polygon.id == this.drawPolygonId
            );

            var tempObj = {};

            (tempObj.id = event.offsetX),
              (tempObj.x = event.offsetX),
              (tempObj.y = event.offsetY),
              this.drawPolygonData[0].coordinates.push(tempObj);
            this.setPolygons();
            this.clicks = 0;
          }, this.delay);
        } else {
          clearTimeout(this.timer);
          this.drawPolygon = false;
          this.polygons[this.polygons.length - 1].displayInfo = true;
          this.setPolygons();
          this.clicks = 0;
        }
      }
    },
    savePoints() {
      if (this.drawPolygon) {
        this.drawPolygon = false;
        this.polygons[this.polygons.length - 1].displayInfo = true;
        this.setPolygons();
        this.selectedFieldName = null;
      }
    },

    getRandomColor(rand) {
      var rgb = [0, 0, 0];
      var color = "rgb(";
      var index = parseInt(Math.random() * 3);
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = parseInt(Math.random() * 151);
      }
      if (rand == 3) {
        rgb[index] = 170;
      } else {
        rgb[rand] = 150;
      }
      color += rgb.join(",");
      color += ")";
      return color;
    },

    getChanges(oldArray, newArray) {
      var changes, i, item, j, len;
      if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
        return false;
      }
      changes = [];
      for (i = j = 0, len = newArray.length; j < len; i = ++j) {
        item = newArray[i];
        if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
          changes.push(item);
        }
      }
      return changes;
    },

    submitImage(ahead) {
      let annotatedFields = [];
      for (var polygon of this.polygons) {
        var coordinates = [];
        for (var coordinate of polygon.coordinates) {
          coordinates.push({ x: coordinate.x, y: coordinate.y });
        }
        if (coordinates.length != 0) {
          annotatedFields.push({
            imageAnnotationFieldId: polygon.fieldId,
            annotationValue: polygon.value,
            coordinates: coordinates,
          });
        }
      }

      if (
        JSON.stringify(annotatedFields) !=
        JSON.stringify(this.initialAnnotations)
      ) {
        Modal.showConfirmationModal({
          message: "Are You Sure You Would Like to Proceed?",
          title: "Confirm Details",
        }).then((confirmed) => {
          if (confirmed) {
            Http()
              .post(
                OCR_ENDPOINTS.imagesAnnotation +
                  this.selectedImageID +
                  "/annotate",
                {
                  override: true,
                  annotatedFields: annotatedFields,
                },
                { showLoader: false }
              )
              .then((response) => {
                this.$toast.success("Image Saved");
                this.$emit("reset");
                if (ahead != null) {
                  this.$parent.navigate(ahead);
                }
                this.initialAnnotations = annotatedFields;
                this.polygons = [];
                for (var annotation of response.data) {
                  this.polygonsAnnotations(annotation);
                }
                this.updateAnnotations(response.data);

                // this.originalPolygons = [];
                // this.setOCRData();
              })
              .catch((error) => {
                console.log(error);
                this.$toast.error("Error Occured");
              })
              .finally(() => {});
          } else {
            if (ahead != null) {
              this.$parent.navigate(ahead);
            }
          }
        });
      } else {
        if (ahead != null) {
          this.$parent.navigate(ahead);
        }
      }
    },
    openContextMenu(event, id) {
      this.showContextMenu = true;
      this.selected(id);
      this.colorDialogTop = document.getElementById("contextMenu").style.height;
      if (document.body.clientWidth < event.pageX + 200) {
        document.getElementById("contextMenu").style.right =
          document.body.clientWidth - event.pageX + "px";
        document.getElementById("contextMenu").style.left = "auto";
      } else {
        document.getElementById("contextMenu").style.left = event.pageX + "px";
        document.getElementById("contextMenu").style.right = "auto";
      }
      document.getElementById("contextMenu").style.top = event.pageY + "px";
      if (document.getElementById(id)) {
        this.selectedPolygonColor = document.getElementById(id).style.stroke;
      }
    },
    openColorMenu(event) {
      this.showColorMenu = true;
      // if (
      //   document.body.clientWidth < event.pageX + 450 &&
      //   document.getElementById("colorMenu")
      // ) {
      //   document.getElementById("colorMenu").style.left = -250 + "px";
      //   document.getElementById("colorMenu").style.right = "auto";
      // } else if (document.getElementById("colorMenu")) {
      //   document.getElementById("colorMenu").style.right = -250 + "px";
      //   document.getElementById("colorMenu").style.left = "auto";
      // }
    },
    resetPolygonToOriginal(id) {
      var index = this.polygons.findIndex((element) => element.id == id);
      this.polygons.splice(index, 1);
      this.submitImage();
      //   this.removePolygonCoordinateLines(id);
      //   var original = this.originalPolygons.find((polygon) => {
      //     return polygon.id == id;
      //   });
      //   var updated = this.polygons.find((polygon) => {
      //     return polygon.id == id;
      //   });
      //   updated.coordinates = _.cloneDeep(original.coordinates);
      //   this.setPolygons();
    },

    deletePolygon(polygonId, fieldId) {
      this.polygons = this.polygons.filter(
        (polygon) => polygon.id != polygonId
      );
      if (!fieldId) {
        return;
      }
      Http()
        .patch(
          OCR_ENDPOINTS.imagesAnnotation + this.selectedImageID + "/annotate",
          {
            annotationId: [fieldId],
          }
        )
        .then((response) => {
          this.$toast.success("Deleted Successfully");
        })
        .catch((error) => {
          this.$toast.error("Error Occured");
          console.error(error);
        });
    },

    recenter(id) {
      var coordinates = this.polygons.find(
        (element) => element.id == id
      ).coordinates;
      var centerCoordinate = {
        x: parseInt(this.imageWidth / 2),
        y: parseInt(this.imageHeight / 2),
      };
      var radius = 100;
      var startingRadian;
      var angle = ((360 / coordinates.length) * Math.PI) / 180;
      if (coordinates.length % 2 != 0) {
        startingRadian = 0;
      } else {
        startingRadian = -(angle / 2);
      }
      for (var coordinate of coordinates) {
        coordinate.adjacentCoordinateX = null;
        coordinate.adjacentCoordinateY = null;
        var distanceX = centerCoordinate.x + radius * Math.sin(startingRadian);
        var distanceY = centerCoordinate.y + radius * Math.cos(startingRadian);
        if (Math.abs(distanceX - coordinate.x) > 1) {
          this.setParameters(
            coordinate.id,
            parseInt(distanceX),
            "x",
            true,
            true
          );
        }
        if (Math.abs(distanceY - coordinate.y) > 1) {
          this.setParameters(
            coordinate.id,
            parseInt(distanceY),
            "y",
            true,
            true
          );
        }
        startingRadian += angle;
      }
    },
    setParameters(id, value, axis, scaled, line) {
      var splitId = id.split("-");
      var coordinate = this.polygons.find(
        (element) => element.id == splitId[0] + "-" + splitId[1]
      ).coordinates[parseInt(splitId[3])];
      if (axis == "x") {
        coordinate.x = value;
        if (scaled) {
          coordinate.scaleX = value;
        }
        if (line && document.getElementById(coordinate.id + "-lineX")) {
          document
            .getElementById(coordinate.id + "-lineX")
            .setAttribute("x1", value);
          document
            .getElementById(coordinate.id + "-lineX")
            .setAttribute("x2", value);
        }
      } else if (axis == "y") {
        coordinate.y = value;
        if (scaled) {
          coordinate.scaleY = value;
        }
        if (line && document.getElementById(coordinate.id + "-lineX")) {
          document
            .getElementById(coordinate.id + "-lineY")
            .setAttribute("y1", value);
          document
            .getElementById(coordinate.id + "-lineY")
            .setAttribute("y2", value);
        }
      }
      this.setPolygons();
    },
    getHeight(coordinates) {
      var yCoordinate = [];
      for (var point of coordinates) {
        yCoordinate.push(point.y);
      }
      return Math.max(...yCoordinate) - Math.min(...yCoordinate);
    },
    getWidth(coordinates) {
      var xCoordinate = [];
      for (var point of coordinates) {
        xCoordinate.push(point.x);
      }
      return Math.max(...xCoordinate) - Math.min(...xCoordinate);
    },
    getCenter(coordinates) {
      var xCoordinate = [];
      var yCoordinate = [];
      for (var point of coordinates) {
        xCoordinate.push(point.scaleX);
        yCoordinate.push(point.scaleY);
      }
      let average = (array) =>
        parseInt(array.reduce((a, b) => a + b) / array.length);
      return { x: average(xCoordinate), y: average(yCoordinate) };
    },
    setDimensions() {
      // this.$emit("loading", false);
      this.imageWidth = document.getElementById("picture").naturalWidth;
      this.imageHeight = document.getElementById("picture").naturalHeight;
      document.getElementById("OCRIMAGE").style.height =
        this.imageHeight + "px";
      document.getElementById("OCRIMAGE").style.width = this.imageWidth + "px";
      document.getElementById("canvas").style.height = this.imageHeight + "px";
      document.getElementById("canvas").style.width = this.imageWidth + "px";
      document.getElementById("picture").style.height = this.imageHeight + "px";
      document.getElementById("picture").style.width = this.imageWidth + "px";
      this.setPolygons();
      this.originalPolygons = _.cloneDeep(this.polygons);
    },
    dragSingle(id) {
      this.polygons.find((element) => element.id == id).moveAdjacent = false;
      this.resetAdjacents(id);
    },
    resetAdjacents(id) {
      for (var coordinate of this.polygons.find((element) => element.id == id)
        .coordinates) {
        coordinate.adjacentCoordinateX = null;
        coordinate.adjacentCoordinateY = null;
      }
    },
    resize(id) {
      this.polygons.find((element) => element.id == id).moveAdjacent = true;
      this.resetAdjacents(id);
    },
    saveOriginPoint(event) {
      this.moveStartX = event.offsetX;
      this.moveStartY = event.offsetY;
    },
    deleteOriginPoint(id) {
      var coordinates = this.polygons.find(
        (element) => element.id == id
      ).coordinates;
      for (var coordinate of coordinates) {
        this.setParameters(coordinate.id, coordinate.y, "y", true, true);
        this.setParameters(coordinate.id, coordinate.x, "x", true, true);
      }
      this.moveStartX = null;
      this.moveStartY = null;
    },
    move(event, id) {
      if (this.moveStartX && this.moveStartY && this.selectedPolygon == id) {
        var coordinates = this.polygons.find(
          (element) => element.id == id
        ).coordinates;
        var moveable = true;
        for (var coordinate of coordinates) {
          var top = coordinate.scaleY + (event.offsetY - this.moveStartY);
          var left = coordinate.scaleX + (event.offsetX - this.moveStartX);
          if (
            this.imageHeight < top ||
            top < 0 ||
            this.imageWidth < left ||
            left < 0
          ) {
            moveable = false;
          }
        }
        if (moveable) {
          for (var coordinate of coordinates) {
            var top = coordinate.scaleY + (event.offsetY - this.moveStartY);
            var left = coordinate.scaleX + (event.offsetX - this.moveStartX);
            if (
              this.imageHeight > top &&
              top > 0 &&
              this.imageWidth > left &&
              left > 0
            ) {
              var elmnt = document.getElementById(coordinate.id);
              this.setParameters(coordinate.id, top, "y", false, true);
              elmnt.style.top = top + "px";
              this.setParameters(coordinate.id, left, "x", false, true);
              elmnt.style.left = left + "px";
            }
          }
        }
      }
    },
    detectBrowser() {
      if (
        (navigator.userAgent.indexOf("Opera") ||
          navigator.userAgent.indexOf("OPR")) != -1
      ) {
        return "Opera";
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        return "Chrome";
      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        return "Safari";
      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        return "Firefox";
      } else if (
        navigator.userAgent.indexOf("MSIE") != -1 ||
        !!document.documentMode == true
      ) {
        return "IE";
      } else {
        return "Unknown";
      }
    },
    drag(event, id) {
      var splitId = id.split("-");
      let self = this;
      dragElement(event.target);
      function dragElement(elmnt) {
        var pos1 = 0,
          pos2 = 0,
          pos3 = 0,
          pos4 = 0;
        if (elmnt) elmnt.onmousedown = dragMouseDown;

        function dragMouseDown(e) {
          e = e || window.event;
          e.preventDefault();
          if (self.detectBrowser() == "Firefox") {
            pos3 = e.screenX;
            pos4 = e.screenY;
          } else {
            pos3 = e.clientX;
            pos4 = e.clientY;
          }
          document.onmouseup = closeDragElement;
          document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
          e = e || window.event;
          e.preventDefault();
          if (self.detectBrowser() == "Firefox") {
            pos1 = pos3 - e.screenX;
            pos2 = pos4 - e.screenY;
            pos3 = e.screenX;
            pos4 = e.screenY;
          } else {
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
          }

          var top = elmnt.offsetTop - pos2;
          var left = elmnt.offsetLeft - pos1;

          var coordinate = self.polygons.find(
            (element) => element.id == splitId[0] + "-" + splitId[1]
          ).coordinates[parseInt(splitId[3])];

          var moveAdjacent = self.polygons.find(
            (element) => element.id == splitId[0] + "-" + splitId[1]
          ).moveAdjacent;

          var coordinates = self.polygons.find(
            (element) => element.id == splitId[0] + "-" + splitId[1]
          ).coordinates;
          var adjacentCoordinateX = coordinate.adjacentCoordinateX,
            adjacentCoordinateY = coordinate.adjacentCoordinateY;
          for (var point of coordinates) {
            if (
              coordinate.x == point.x &&
              !adjacentCoordinateX &&
              point.id != adjacentCoordinateY &&
              point.id != coordinate.id
            ) {
              adjacentCoordinateX = point.id;
              coordinate.adjacentCoordinateX = point.id;
            }
            if (
              coordinate.y == point.y &&
              !adjacentCoordinateY &&
              point.id != adjacentCoordinateX &&
              point.id != coordinate.id
            ) {
              adjacentCoordinateY = point.id;
              coordinate.adjacentCoordinateY = point.id;
            }
          }
          if (self.imageHeight > top && top > 0) {
            self.setParameters(coordinate.id, top, "y", true, true);
            elmnt.style.top = top + "px";
            if (
              adjacentCoordinateY &&
              document.getElementById(adjacentCoordinateY) &&
              moveAdjacent
            ) {
              document.getElementById(adjacentCoordinateY).style.top =
                top + "px";
              self.setParameters(adjacentCoordinateY, top, "y", true, true);
            } else if (
              adjacentCoordinateY &&
              !document.getElementById(adjacentCoordinateY)
            ) {
              coordinate.adjacentCoordinateY = null;
            }
          }
          if (self.imageWidth > left && left > 0) {
            self.setParameters(coordinate.id, left, "x", true, true);
            elmnt.style.left = left + "px";
            if (
              adjacentCoordinateX &&
              document.getElementById(adjacentCoordinateX) &&
              moveAdjacent
            ) {
              self.setParameters(adjacentCoordinateX, left, "x", true, true);
              document.getElementById(adjacentCoordinateX).style.left =
                left + "px";
            } else if (
              adjacentCoordinateY &&
              !document.getElementById(adjacentCoordinateX)
            ) {
              coordinate.adjacentCoordinateX = null;
            }
          }
          // self.polygons.find(
          //   (element) => element.id == splitId[0] + "-" + splitId[1]
          // ).scale = 100;
        }

        function closeDragElement() {
          document.onmouseup = null;
          document.onmousemove = null;
        }
      }
      this.modifyPolygon = true;
    },
    selected(id) {
      this.selectedPolygon = id;
    },
    changeColor(color) {
      var polygon = this.polygons.find(
        (element) => element.id == this.selectedPolygon
      );
      polygon.color =
        "rgb(" + color.rgba.r + "," + color.rgba.g + "," + color.rgba.b + ")";
      this.selectedPolygonColor =
        "rgb(" + color.rgba.r + "," + color.rgba.g + "," + color.rgba.b + ")";
    },
    toggle(id) {
      var index = this.polygons.findIndex((element) => element.id == id);
      this.polygons[index].display = !this.polygons[index].display;
    },
    toggleFieldPolygons(fieldId) {
      for (var index = 0; index < this.polygons.length; index++) {
        if (fieldId == this.polygons[index].fieldId) {
          this.polygons[index].display = !this.polygons[index].display;
        }
      }
    },

    toggleAll() {
      for (var polygon of this.polygons) {
        this.toggle(polygon.id);
      }
    },
    toggleOthers(id) {
      var index = this.polygons.findIndex((element) => element.id == id);
      for (var i = 0; i < this.polygons.length; i++) {
        if (i == index) {
          this.polygons[i].display = true;
        } else {
          this.polygons[i].display = false;
        }
      }
    },
    removePolygonCoordinateLines(id) {
      var coordinates = this.polygons.find(
        (element) => element.id == id
      ).coordinates;
      for (var coordinate of coordinates) {
        this.removePointCoordinateLines(coordinate.id);
      }
    },
    displayLabel(id, trigger) {
      var index = this.polygons.findIndex((element) => element.id == id);
      if (document.getElementById(id + "-label"))
        document.getElementById(id + "-label").style.display =
          trigger && this.polygons[index].display ? "inline" : "none";
    },
    displayLineY(id, trigger) {
      if (document.getElementById(id + "-lineY"))
        document
          .getElementById(id + "-lineY")
          .setAttribute("stroke", trigger ? "red" : "transparent");
    },
    displayLineX(id, trigger) {
      if (document.getElementById(id + "-lineX"))
        document
          .getElementById(id + "-lineX")
          .setAttribute("stroke", trigger ? "red" : "transparent");
    },
    addPolygonLines(id) {
      var polygon = this.polygons.find((element) => element.id == id);
      for (var coordinate of polygon.coordinates) {
        this.addCoordinateLines(coordinate.id);
      }
    },
    addCoordinateLines(id) {
      var splitId = id.split("-");
      var coordinate = this.polygons.find(
        (element) => element.id == splitId[0] + "-" + splitId[1]
      ).coordinates[parseInt(splitId[3])];
      if (
        !document.getElementById(coordinate.id + "-lineY") &&
        !document.getElementById(coordinate.id + "-lineX")
      ) {
        var svg = document.getElementById("canvas");
        var lineX = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "line"
        );
        lineX.setAttribute("id", coordinate.id + "-lineX");
        for (var property of Object.keys(coordinate.lineX)) {
          lineX.setAttribute(property, coordinate.lineX[property]);
        }
        lineX.setAttribute("stroke", "none");
        lineX.setAttribute("stroke-width", "1");
        var lineY = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "line"
        );
        lineY.setAttribute("id", coordinate.id + "-lineY");
        for (var property of Object.keys(coordinate.lineY)) {
          lineY.setAttribute(property, coordinate.lineY[property]);
        }
        lineY.setAttribute("stroke", "none");
        lineY.setAttribute("stroke-width", "1");
        svg.append(lineX);
        svg.append(lineY);
      }
    },
    removePointCoordinateLines(id) {
      document.getElementById(id + "-lineX").remove();
      document.getElementById(id + "-lineY").remove();
    },
    addPolygon(id) {
      var index = this.polygons.findIndex((element) => element.id == id);
      var centerHeight = this.imageHeight / 2;
      var centerWidth = this.imageWidth / 2;

      this.newPolygon();

      var newCoordinates = [
        { x: centerWidth - 50, y: centerHeight - 50 },
        { x: centerWidth + 50, y: centerHeight - 50 },
        { x: centerWidth + 50, y: centerHeight + 50 },
        { x: centerWidth - 50, y: centerHeight + 50 },
      ];
      this.polygons[index].coordinates = newCoordinates;
      this.setPolygons();
    },

    newPolygon() {},
  },
};
</script>
<style scoped>
.dot {
  height: 10px;
  width: 10px;
  background-color: rgb(35, 79, 255);
  display: inline-block;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.box {
  height: 13px;
  width: 13px;
  display: inline-block;
  transform: translate(-50%, -50%);
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  outline: none;
  opacity: 0.7;
  border: black 1px solid;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: black;
  cursor: pointer;
}

#contextMenu {
  width: 200px;
  position: absolute;
  border: 2px black solid;
  z-index: 10;
}

#contextMenu ul li {
  background: #ccc;
}

#contextMenu ul li:hover {
  background: rgb(108, 179, 255);
}

svg {
  stroke-dasharray: 0%;
}

.pinch-scroll-zoom__content {
  position: relative !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

#tooltip-span {
  display: none;
  position: absolute;
  color: red;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px;
  border-radius: 5px;
  opacity: 1;
}

#options:hover {
  color: white !important;
  background-color: #e40046 !important;
}

.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
.overflow{
  height: 70vh; 
  overflow-y: hidden;
}
.overflow:hover{
  overflow-y: auto !important;
}

</style>
